import AssignmentDetailsContainer from './AssignmentDetailsContainer';

export default AssignmentDetailsContainer;
